import { Component } from 'react';

import { InfoBlockProps } from '../InfoBlock';
import WaveEventButtons from '../WaveEventButtons';

import WaveEventInfoWithButtonsWrapper, {
  WaveEventInfoBordered
} from './Wrapper';

export interface WaveEventInfoWithButtonsProps {
  info: InfoBlockProps;
  onBack: () => void;
}

class WaveEventInfoWithButtons extends Component<
  WaveEventInfoWithButtonsProps
> {
  render() {
    const { info, onBack } = this.props;

    return (
      <WaveEventInfoWithButtonsWrapper>
        <WaveEventInfoBordered info={info}>
          <WaveEventButtons onBack={onBack} />
        </WaveEventInfoBordered>
      </WaveEventInfoWithButtonsWrapper>
    );
  }
}

export default WaveEventInfoWithButtons;
